module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAdBAMAAAA9RaOJAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAJFBMVEXzKTP0R0/5wr70PUb5wr/7+fH62NP62dT1T1f79Oz79O0AAAC9OBvVAAAAAWJLR0QLH9fEwAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAF9JREFUKM9jYBiMgFEZSDA7IomwhBkwMJiHIIkwlyYzMKcWI2szDzMwCzdgQFGUgaoEqCgSVQkDA8fUGWj2m0WFoaphTq0AWoeiJNzAHEURc2oy2E0IwIThZkx/DR4AAGp4EBtA3tvlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/btn-close-ov.png
// module id = 1507
// module chunks = 0